export const GENERAL_CONSTS = {
    GET_STATIC_TEXTS: "GET_STATIC_TEXTS",
    GET_LANGUAGES: "GET_LANGUAGES",
    CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
    SEND_SUBSCRIBERS: "SEND_SUBSCRIBERS",
    GET_SLIDER_HOME: "GET_SLIDER_HOME",
    GET_SLIDER_BANNER: "GET_SLIDER_BANNER",
    IS_OPEN: "IS_OPEN",
    GET_CONTACTS: "GET_CONTACTS",
    SEND_CONTACTS: "SEND_CONTACTS",
    GET_ABOUT: "GET_ABOUT",
    GET_ADVERTISEMENT: "GET_ADVERTISEMENT",
};

